<template>
	<v-row v-if="person">
		<!-- region -->
		<v-col cols="12" md="6">
			<v-select
				v-model.trim="person.region"
				:disabled="disableEdit"
				label="Región"
				:items="regiones"
				outlined
				solo
				dense
				filled
				@change="setComunas"
			></v-select>
		</v-col>
		<!-- comuna -->
		<v-col cols="12" md="6">
			<v-select
				v-model.trim="person.comuna"
				label="Comuna"
				:items="comunas"
				outlined
				solo
				eager
				dense
				filled
				:disabled="disableEdit || disableComunaInput"
			></v-select>
		</v-col>
		<v-col cols="12">
			<v-btn
				block
				:disabled="!hasChangeForm"
				:loading="loading"
				small
				color="success"
				@click="submit"
			>
				Guardar
			</v-btn>
		</v-col>
	</v-row>
</template>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';
import { isEqual, cloneDeep } from 'lodash';

export default {
	props: {
		disableEdit: { type: Boolean, default: false },
		personProps: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			disableComunaInput: true,
			regiones: [],
			comunas: [],
			comunasRegiones: [],
			loading: false,
			person: null,
		};
	},
	computed: {
		hasChangeForm() {
			return !isEqual(this.personProps, this.person);
		},
	},
	mounted() {
		this.person = cloneDeep(this.personProps);
		this.fetchRegions();
	},
	methods: {
		async submit() {
			if (this.hasChangeForm) {
				this.loading = true;
				await this.putPerson({ ...this.person });
				this.loading = false;
			}
		},
		async fetchRegions() {
			const response = await axios(
				`${process.env.VUE_APP_URL_ABSOLUTE}/comunas-regiones.json`
			);
			this.comunasRegiones = response.data;
			this.regiones = this.comunasRegiones.map(item => item.region);
		},
		setComunas() {
			let temp = this.comunasRegiones.filter(item => item.region === this.person.region);
			this.comunas = temp[0].comunas;
			this.disableComunaInput = false;
		},
		...mapActions({
			putPerson: 'Person/putPerson',
		}),
	},
	watch: {
		comunasRegiones(newValue) {
			if (newValue) this.person = cloneDeep(this.personProps);
		},
		regiones(newValue) {
			if (newValue && this.person.region && this.person.comuna) {
				this.setComunas();
			}
		},
		personProps() {
			this.person = cloneDeep(this.personProps);
		},
	},
};
</script>
